import template from 'lodash/template';

import domains from '../containers/Domains';
import { creds } from '../config/FBAdOps';
import { getLocalStorageDataOrFetch } from './fbCallManager';

import { pageIds as nuPageIds } from './../constants/nissan-united';

const endpoint = domains.fbEndpoint;

export const getPage = async (pageId, token) => {
  const parameters = {
    access_token: token,
    page_id: pageId,
    fields: 'id,access_token,name'
  };

  const query = template(
    `${endpoint}<%= page_id%>?fields=<%= fields%>&access_token=<%= access_token%>`
  );
  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));
  return jsonResult;
};

export const getPageBackedInstagramAccounts = async (pageId, token) => {
  const parameters = {
    access_token: token,
    page_id: pageId
  };

  const query = template(
    `${endpoint}<%= page_id%>/page_backed_instagram_accounts?&access_token=<%= access_token%>`
  );
  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));
  return jsonResult;
};

export const getPageWithPageToken = async (pageId, token) => {
  const parameters = {
    access_token: token,
    page_id: pageId,
    fields: 'id,access_token,name,instagram_accounts,instagram_business_account'
  };

  const query = template(
    `${endpoint}<%= page_id%>?fields=<%= fields%>&access_token=<%= access_token%>`
  );
  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));
  return jsonResult;
};

export const getPages = async (token, userGroup) => {
  const parameters = {
    app_id: creds.appId,
    access_token: token,
    fields: 'name,access_token',
    limit: 2000
  };

  const allPages = await Promise.all([    
    new Promise(async (resolve) => {
      // console.log("calling allPages");
      const clientQuery = template(
        `${endpoint}<%= app_id%>/client_pages?fields=<%= fields%>&access_token=<%= access_token%>&limit=<%= limit%>`
      );
      const clientPagesResult = await getLocalStorageDataOrFetch(
        clientQuery(parameters),
        true
      );
      // console.log("calling allPages - done");
      resolve(clientPagesResult);
    }),
    new Promise(async (resolve) => {
      const ownedQuery = template(
        `${endpoint}<%= app_id%>/owned_pages?fields=<%= fields%>&access_token=<%= access_token%>&limit=<%= limit%>`
      );
      const ownedPagesResult = await getLocalStorageDataOrFetch(
        ownedQuery(parameters)
      );
      resolve(ownedPagesResult);
    })
  ]);

  const filteredAllPages = allPages.map((pagesObj) => {
    const pages = pagesObj ? pagesObj.data : [];
    let finalPages = pages;

    // switch case leaves room for expansion to other clients in the future
    switch (userGroup) {
      case 'NU':
        finalPages = pages.filter((pageObj) =>
          nuPageIds.includes(`${pageObj.id}`)
        );
        break;
      default:
        break;
    }

    return { ...pagesObj, data: finalPages };
  });

  return filteredAllPages;
};



// WEBPACK FOOTER //
// ./src/fbApi/Page.js